/* eslint-disable jsx-a11y/label-has-associated-control */
// eslint-disable-next-line react/jsx-curly-newline
import React, { useState } from 'react';
import error from '../images/rename.png';


const PayWithBank = (props) => {
  const { handleStateChange,
    handleInvalidFields,
    validateChecked,
    email,
    zipCode,
    achChecked,
    cbToS,
    labelCountry,
    formErrors
  } = props;


  return (
    <>
      <div className="form-group">
        <label className="inputLabel" style={{ display: 'none' }}>Email</label>
        <input
          className="input-group my-1 p-1 border"
          value={email}
          name="email"
          placeholder="Email"
          onChange={(e) => handleStateChange(e)}
          style={{ display: 'none' }}
        />
        <span style={formErrors.email.length > 0 ? { display: 'inline', color: 'red' } : { display: 'none' }}>
          <img alt="error" src={error} />
          {formErrors.email}
        </span>   
      </div>
      <div className="form-group">
        <label className="inputLabel">{labelCountry}</label>
        <select className="form-control">
          <option>United States</option>
        </select>
        <i className="fa fa-chevron-down" />
        <input
          type="text"
          className="input-group p-1 border"
          value={zipCode}
          name="zipCode"
          placeholder="ZIP"
          onChange={(e) => handleStateChange(e)}
        />
        <span style={formErrors.zipCode.length > 0 ? { display: 'inline', color: 'red' } : { display: 'none' }}>
          <img alt="error" src={error} />
          {formErrors.zipCode}
        </span>
        <div style={{ display: 'flex', width: '100%' }}>
          <label className="agree-label">
          <input
            className="agree-checkbox"
            type="checkbox"
            style={{ verticalAlign: 'bottom' }}
            checked={achChecked}
            onChange={(e) => { validateChecked(e); }}
            onBlur={(e) => handleInvalidFields(e)}
          />
            <span style={{ verticalAlign: 'top' }}>{cbToS}</span>
          </label>
          <div style={ formErrors.achChecked.length > 0 ? { display: 'inline', color: 'red', textAlign: 'right' } : { display: 'none' }}>
              <img alt="error" src={error} />
              {formErrors.achChecked}
          </div>
        </div>
      </div>
    </>
  );
}

export default PayWithBank;